// require('dotenv').config()
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// import Home from "./pages/Home";
import Book from "./pages/book";

import BlogDetails from "./pages/blog_details";
import BlogDetailsNew from "./pages/blog_details_new";
import Sucesspage from "./pages/sucesspage";

import { ToastContainer } from "react-toastify";
// import CareerChoose from "./pages/careerChoose";
// import CEX from "./pages/service/Cex";
import CexNew from "./pages/service/CexNew";
import Corbontrade from "./pages/service/Corbontrade";
import BetfuryClone from "./pages/service/BetfuryClone";
import CryptoWallet from "./pages/service/CryptoWallet";

import P2P from "./pages/service/P2P";
// import CLONECEX from "./pages/service/Cexclone";

import ICO from "./pages/service/ICO";
import IEO from "./pages/service/IEO";
import MarketMakeing from "./pages/service/MarketMakeing";
import Arbitrage from "./pages/service/Arbitrage";
import Binace from "./pages/service/Binance";
import OpenSea from "./pages/service/OpenSea";
import Rarible from "./pages/service/Rarible";
import MLM from "./pages/service/MLM";
import SmartRouting from "./pages/service/SmartRouting";
import Whitelable from "./pages/service/Whitelable";
import Dex from "./pages/service/Dex";
import LocalBIt from "./pages/service/LocalBIt";
import OTC from "./pages/service/OTC";
import Paymentgateway from "./pages/service/Paymentgateway";
import Blockchaindev from "./pages/service/Blockchaindev";
import Defi from "./pages/service/Defi";
import DefiStaking from "./pages/service/DefiStaking";
import Launchpad from "./pages/service/Launchpad";
// import Contactus from "./pages/Contactus";
// import Blogpage from "./pages/service/Blogpage";
import ISO from "./pages/service/ISO";
import SmartContractAudit from "./pages/service/SmartContractAudit";
import BlockchainGame from "./pages/service/BlockchainGame";
import PancakeScript from "./pages/service/PancakeScript";

import CryptoToken from "./pages/service/CryptoToken";
import Nftgame from "./pages/service/NFTgame";
import WebSolution from "./pages/service/Web3solution";
import CryptoExhcnge from "./pages/service/CryptoExhcnge";
import META from "./pages/service/Metaverse";
import DAO from "./pages/service/DAO";
import CadanoBlock from "./pages/service/CadanoBlock";
import AiandMl from "./pages/service/AiandMl";
import Coinbase from "./pages/service/Coinbase";
import Nftnewpage from "./pages/service/Nftnewpage";
import Dapp from "./pages/service/Dapp";
import StableCoin from "./pages/service/StableCoin";

// import CEXNew from "./pages/service/CexNew";
import MetaverseNft from "./pages/service/MetaverseNft";
import Bitcoinmining from "./pages/service/Bitcoinmining";
import Memecoin from "./pages/service/Memecoin";
import Paxfulclone from "./pages/service/Paxfulclone";
import WazirxClone from "./pages/service/WazirxClone";
import Cbdc from "./pages/service/Cbdc";
import DungeonSwap from "./pages/service/Dungeonswap";
import Cryptolisting from "./pages/service/Cryptolisting";
import Tradingbot from "./pages/service/Tradingbot";

import Veralistiong from "./pages/service/Veralistiong";
import Careerdetails from "./pages/Careerdetails";
import GenAi from "./pages/service/GenAi";
import Rwa from "./pages/service/Rwa";
import EVMbot from "./pages/service/EVMbot";

import SemiFT from "./pages/service/SFT";
import Blog from "./pages/Blog";
import A404 from "./pages/404";
import Cryptoderivateive from "./pages/service/Cryptoderivateive";
import CareerNew from "./pages/Careernew";
import CentralizedCrypto from "./pages/service/Centralized_Crypto ";
import SolanaMeme from "./pages/service/Solana_Meme";
import AlgoTrading from "./pages/service/AlgoTrading";
import FlashLoaan from "./pages/service/FlashLoan";
import Casino from "./pages/service/Casino";
import OwnBlockchain from "./pages/service/OwnBlockchain";
import ForexSolutions from "./pages/service/ForexSolutions";
import Landing from "./pages/landing/Landing";
import UberClone from "./pages/service/uberclone/UberClone";

import Stakingcard from "./pages/landing/Stakingcard";
import ScrollToTop from "./ScrollToTop";
import NewContactus from "./pages/NewContactus";
// import Aboutus from "./pages/Aboutus";
// import NewCareer from "./pages/NewCareer";
import MobileApp from "./pages/service/mobileapp/MobileApp";
import ZerodhaClone from "./pages/service/zerodha/ZerodhaClone";
import FIU from "./pages/service/FIU-Consultant/FIU";
import AIAgent from "./pages/service/AI-Agent/AIAgent";
import Etoro from "./pages/service/Etoro/Etoro";
import Customsoftware from "./pages/service/custom-software/Customsoftware";
import Stocktrading from "./pages/service/Stock Trading/Stocktrading";
import Polymarket from "./pages/service/Polymarket/Polymarket";
import Phonepe from "./pages/service/Phonepe/Phonepe";
import Realestate from "./pages/service/Realestate/Realestate";
import Forextrading from "./pages/service/ForexTrading/Forextrading";
import Datingapp from "./pages/service/DatingApp/Datingapp";
import FoodDelivery from "./pages/service/FoodDelivery/FoodDelivery";
import Healthcare from "./pages/service/Healthcare/Healthcare";
import Amazonclone from "./pages/service/Amazonclone/Amazonclone";
import Supplychain from "./pages/service/Supplychain/Supplychain";
import Airbnb from "./pages/service/Airbnb/Airbnb";
import MachineLearning from "./pages/service/Machinelearning/MachineLearning";
import AIcryptoBlog from "./pages/BlogNew/AIcryptoBlog";
import Margintrading from "./pages/service/MarginTrading/Margintrading";
// import PressRelease from "./pages/PressRelease";
import Lendingapp from "./pages/service/Lendingapp/Lendingapp";
import PressRelease from "./pages/service/Pressrelease/PressRelease";
import Cashadvance from "./pages/service/Pressrelease/Cashadvance";
import Cryptoexchange from "./pages/service/Pressrelease/Cryptoexchange";
import BuildCEX from "./pages/service/Pressrelease/BuildCEX";
import GoldTrading from "./pages/service/Pressrelease/GoldTrading";
import CurrencyTrading from "./pages/service/Pressrelease/CurrencyTrading";
import Cryptolicense from "./pages/service/Cryptolicense/Cryptolicense";
import Proboclone from "./pages/service/Pressrelease/Proboclone";

function App() {
  return (
    <>
      {/* <BrowserRouter basename="/testing"> */}
      {/* <BrowserRouter> */}
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/landing" element={<Landing />} />
          <Route path="/home" element={<Landing />} />
          {/* <Route path="/" element={<Landing />} /> */}
          <Route path="/stakingcards" element={<Stakingcard />} />
          {/* <Route path="/homenew" element={<HomeNew />} /> */}
          {/* <Route path="/blog_details" element={<BlogDetailsNew />} /> */}
          <Route path="/blog_details" element={<BlogDetails />} />
          <Route path="/catogary/:id" element={<BlogDetails />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/:id" element={<Blog />} />
          {/* <Route path="/about-us" element={<Aboutus />} /> */}
          <Route path="/career" element={<CareerNew />} />
          {/* <Route path="/new-career" element={<NewCareer />} /> */}
          {/* <Route path="/career" element={<Career />} /> */}
          <Route path="/book" element={<Book CLONECEX />} />
          <Route path="/sucesspage" element={<Sucesspage />} />
          {/* <Route path="/service" element={<OurService />} /> */}
          {/* <Route path="/thankscareer" element={<CareerChoose />} /> */}
          <Route
            path="/centralized-cryptocurrency-exchange-development"
            element={<CexNew />}
          />
          <Route
            path="/metaverse-nft-marketplace-development-company"
            element={<MetaverseNft />}
          />
          <Route
            path="/blockchain-based-carbon-credit-platform-Development"
            element={<Corbontrade />}
          />
          <Route
            path="/betfury-clone-script-development-company"
            element={<BetfuryClone />}
          />
          <Route
            path="/crypto-wallet-app-development"
            element={<CryptoWallet />}
          />
          <Route path="/dapp-development-company" element={<Dapp />} />
          <Route
            path="/bitcoin-mining-software-development"
            element={<Bitcoinmining />}
          />
          <Route
            path="/crypto-trading-bot-development-company"
            element={<Tradingbot />}
          />
          <Route path="/meme-coin-development-company" element={<Memecoin />} />
          <Route
            path="/paxful-clone-script-development-company"
            element={<Paxfulclone />}
          />
          <Route
            path="/wazirx-clone-script-development"
            element={<WazirxClone />}
          />
          <Route path="/crypto-listing-agency" element={<Cryptolisting />} />
          <Route path="/vara-license-consultant" element={<Veralistiong />} />
          <Route
            path="/forex-trading-software-development"
            element={<ForexSolutions />}
          />{" "}
          <Route path="/uber-clone" element={<UberClone />} />
          <Route
            path="/generative-ai-development-company"
            element={<GenAi />}
          />
          <Route path="/mev-bot-development-company" element={<EVMbot />} />
          <Route path="/real-world-asset-token-development" element={<Rwa />} />
          <Route path="/semi-fungible-token-development" element={<SemiFT />} />
          <Route path="/careerdetails/:id/:id" element={<Careerdetails />} />
          <Route path="/web3-development-solution" element={<WebSolution />} />
          {/* <Route path="/metaverse-development" element={<META />} /> */}
          <Route path="/dao-development-company" element={<DAO />} />
          
          {/* press release pages */}
          <Route
            path="/roksy-the-best-meme-coin-to-buy-now"
            element={<PressRelease />}
          />
          <Route
            path="/cash-advance-app-development-like-wagetap"
            element={<Cashadvance />}
          />
          <Route
            path="/crypto-exchange-software-development"
            element={<Cryptoexchange />}
          />
          <Route path="/how-to-build-crypto-exchange" element={<BuildCEX />} />
          <Route path="/Gold-Trading-Bot" element={<GoldTrading />} />
          <Route path="/Currency-Trading-Bot" element={<CurrencyTrading />} />
          <Route path="/probo-clone" element={<Proboclone />} />
          <Route
            path="/cardano-blockchain-development-company"
            element={<CadanoBlock />}
          />
          <Route
            path="/cryptocurrency-exchange-script"
            element={<CentralizedCrypto />}
          />
          <Route path="/metaverse-development-company" element={<META />} />
          {/* <Route
            path="/nft-marketplace-development-services"
            element={<NFT />}
          /> */}
          <Route
            path="/nft-marketplace-development-service"
            element={<Nftnewpage />}
          />
          <Route path="/nft-game-development-company" element={<Nftgame />} />
          <Route
            path="/pancakeswap-clone-script-development"
            element={<PancakeScript />}
          />
          <Route path="/defi-development-company" element={<Defi />} />
          <Route
            path="/enterprise-blockchain-development-company"
            element={<Blockchaindev />}
          />
          <Route
            path="/stablecoin-development-company"
            element={<StableCoin />}
          />
          <Route
            path="/p2p-cryptocurrency-exchange-development-company"
            element={<P2P />}
          />
          <Route
            path="/white-label-cryptocurrency-exchange-software"
            element={<Whitelable />}
          />
          <Route
            path="/defi-staking-platform-development"
            element={<DefiStaking />}
          />
          <Route
            path="/crypto-launchpad-development-company"
            element={<Launchpad />}
          />
          <Route path="/ico-development-company" element={<ICO />} />
          <Route path="/coinbase-clone-script" element={<Coinbase />} />
          <Route
            path="/smart-contract-auditing-service-company"
            element={<SmartContractAudit />}
          />
          <Route path="/token-development-company" element={<CryptoToken />} />
          <Route
            path="/cryptocurrency-exchange-development-company"
            element={<CryptoExhcnge />}
          />
          {/* <Route path="/contact-us" element={<Contactus />} /> */}
          <Route path="/contact-us" element={<NewContactus />} />
          <Route path="/ieo-development-company" element={<IEO />} />
          <Route path="/sto-development-company" element={<ISO />} />
          <Route path="/crypto-arbitrage-trading-bot" element={<Arbitrage />} />
          <Route
            path="/binance-clone-script-development"
            element={<Binace />}
          />
          <Route path="/opensea-clone-script" element={<OpenSea />} />
          <Route path="/rarible-clone-script" element={<Rarible />} />
          <Route
            path="/cryptocurrency-mlm-software-development"
            element={<MLM />}
          />
          <Route
            path="/central-bank-digital-currency-development-company"
            element={<Cbdc />}
          />
          <Route
            path="/crypto-market-making-services"
            element={<MarketMakeing />}
          />
          <Route
            path="/crypto-smart-order-routing-services"
            element={<SmartRouting />}
          />
          <Route path="/local-bitcoin-clone" element={<LocalBIt />} />
          <Route
            path="/crypto-otc-trading-platform-development"
            element={<OTC />}
          />
          <Route
            path="/crypto-payment-gateway-development-services"
            element={<Paymentgateway />}
          />
          <Route
            path="/blockchain-game-development"
            element={<BlockchainGame />}
          />
          <Route
            path="/decentralized-cryptocurrency-exchange-development"
            element={<Dex />}
          />
          <Route
            path="/crypto-derivatives-exchange-development"
            element={<Cryptoderivateive />}
          />
          <Route
            path="/dungeonswap-clone-script-development-company"
            element={<DungeonSwap />}
          />
          <Route path="/ai-and-ml-development-company" element={<AiandMl />} />
          <Route path="/page-not-found" element={<A404 />} />
          <Route path="*" element={<A404 />} />
          <Route path="/solana-meme-coin" element={<SolanaMeme />} />
          <Route
            path="/crypto-algo-trading-bot-development"
            element={<AlgoTrading />}
          />
          <Route
            path="/crypto-flash-loan-arbitrage-bot-development"
            element={<FlashLoaan />}
          />
          <Route path="/crypto-casino-game-development" element={<Casino />} />
          <Route
            path="/own-blockchain-development-company"
            element={<OwnBlockchain />}
          />
          <Route
            path="/mobile-app-development-company"
            element={<MobileApp />}
          />
          <Route path="/zerodha-clone-app" element={<ZerodhaClone />} />
          <Route path="/fiu-consultant" element={<FIU />} />
          <Route path="/ai-agent-development-company" element={<AIAgent />} />
          <Route path="/etoro-clone" element={<Etoro />} />
          <Route
            path="/custom-software-development-company"
            element={<Customsoftware />}
          />
          <Route
            path="/stock-trading-app-development-company"
            element={<Stocktrading />}
          />
          <Route path="/polymarket-clone-script" element={<Polymarket />} />
          <Route path="/phonepe-clone-app" element={<Phonepe />} />
          <Route path="/real-estate-tokenization" element={<Realestate />} />
          <Route path="/forex-trading-bot" element={<Forextrading />} />
          <Route
            path="/dating-app-development-company"
            element={<Datingapp />}
          />
          <Route
            path="/food-delivery-app-development-company"
            element={<FoodDelivery />}
          />
          <Route
            path="/healthcare-app-development-company"
            element={<Healthcare />}
          />
          <Route path="/amazon-clone" element={<Amazonclone />} />
          <Route
            path="/supply-chain-software-development"
            element={<Supplychain />}
          />
          <Route path="/airbnb-clone" element={<Airbnb />} />
          <Route
            path="/machine-learning-consulting-services"
            element={<MachineLearning />}
          />
          <Route
            path="/margin-trading-exchange-development"
            element={<Margintrading />}
          />
          {/* <Route
            path="/loan-lending-app-development"
            element={<Lendingapp />}
          /> */}
          <Route path="/crypto-licensing" element={<Cryptolicense />} />
          {/* <Route path="/how-to-develop-an-ai-crypto-trading-platform" element={<AIcryptoBlog />} /> */}
          {/* <Route path="/" element={<Centralized_Crypto/>}/> {<CLONECEX />} */}
          {/* <Route path="service/:id" element={<OurService />} /> */}
          {/* blog type page */}
          {/* <Route path="/pancakeswap-clone-script" element={<Blogpage />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
